module.exports = __webpack_public_path__ + "img/PackRat.99769282.png";